import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { OrderBlockedService } from './services/order-blocked.service';
import { ListOrderTracking } from './model/order-blocked.model';
import { BoolToAffirmation } from '../../common/custom.datepipe';

@Component({
  selector: 'app-order-blocked-component',
  templateUrl: './order-blocked.component.html',
  styleUrls: ['./order-blocked.component.css']
})

export class OrderBlockedComponent implements OnInit {
  currentUser: {};
  txtSearch: string = "*";
  loading: boolean;

  changeTo: boolean;
  textConfirm: string;
  textError: string;

  public page: number = 1;
  public pageSize: number;
  public total: number;

  public orderTrackings: ListOrderTracking[];
  public orderTrackingSelected: ListOrderTracking;
  orderBlockedSelected: string = "pending-verification";

  constructor(
    private orderBlockedService: OrderBlockedService
  ) {
  }

  ngOnInit() {
    if (!this.loggedUser()) {
      window.location.href = "/authentication";
    }
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.getOrders();
  }

  public doSearch($event: Event) {
    this.txtSearch = ($event.target as HTMLInputElement).value;
    this.getOrders();
  }

  public doSearchClear() {
    this.txtSearch = "*";
    this.getOrders();
  }

  public refrehPage() {
    this.getOrders();
  }

  public getOrders() {
    this.loading = true;
    this.orderTrackings = [];
    if (this.page <= 0)
      this.page = 1;
    this.orderBlockedService.getOrderBlocked(this.txtSearch, this.page, this.orderBlockedSelected)
      .subscribe(result => {
        try {
          this.loading = false;
          this.orderTrackings = result.listOrderTracking;
          this.pageSize = result.pageSize;
          this.total = result.totalRecords;
        } catch (er) {
          this.loading = false;
          this.pageSize = result.pageSize;
          this.page = 1;
          this.total = result.totalRecords;
        }
      }, fail => {
        this.loading = false;
        this.pageSize = this.pageSize;
        this.page = 1;
        this.total = 0;
    });
  }

  public openModalFraudAnalysis(modelName, $event, item: ListOrderTracking) {
    this.orderTrackingSelected = item;
    this.openModal(modelName, $event)
  }

  public releaseOrder(modelName, $event, changeTo: boolean) {
    this.changeTo = changeTo;
    this.textConfirm = changeTo ? "Você confirma a liberação deste pedido?" : "Você confirma o bloqueio deste pedido?";

    this.openModal(modelName, $event)
  }

  public setOrderResultFraudAnalysis() {
    this.closeModal("modalAlert");
    this.loading = true;
    let resultAnalysis = this.changeTo ? "released" : "not-released";
    this.orderBlockedService.putResultFraudAnalysis(this.orderTrackingSelected.id, resultAnalysis)
      .subscribe(result => {
        if (result.success) {
          this.closeModal("modalFraudAnalysis");
          this.orderTrackingSelected = null;
          this.changeTo = null;
          this.refrehPage();
        } else {
          this.textError = result.returnMessage;
          this.loading = false;
          this.openModal("modalError", null);
        }
      }, result => {
        this.orderTrackingSelected = null;
        this.changeTo = null;
      });
  }

  public openModal(modelName, $event) {
    try {
      document.getElementById(modelName).style.display = "block";
      document.getElementById(modelName).style.backgroundColor = "rgba(12, 0, 0, 0.5)";
    } catch (e) {
      let that = this;
      setTimeout(function () { that.openModal(modelName, $event); }, 500);
    }
  }

  public closeModal(modelName) {
    document.getElementById(modelName).style.display = "none";
  }

  public pageChanged(page) {
    this.page = page;
    this.getOrders();
  }

  public changeOrderBlocked(orderBlocked: string) {
    this.orderBlockedSelected = orderBlocked;
    this.getOrders();
  }

  loggedUser() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      return true;
    }
  }
}

